import {
  buildBondPrincipalAttorneySelectionHandler,
  useBondGuardianAttorneySearch,
} from "../utils/bondGuardianAttorneyWiring";
import { BondGuardianAttorneySearchForPrincipal } from "./BondGuardianAttorneySearch";

export { buildBondPrincipalAttorneySearchSectionProps } from "../utils/bondGuardianAttorneyWiring";

export function BondPrincipalAttorneySearchSection({
  apiClient,
  role,
  lawfirmId,
  toast,
  updateData,
  data,
  guardians,
  guardian,
  guardianIndex,
  selectionHandler,
  fieldError = "",
  required = false,
  children,
}) {
  const { attorneySearch } = useBondGuardianAttorneySearch({
    apiClient,
    role,
    lawfirmId,
    toast,
  });
  const { attorneys } = attorneySearch;

  const onSelect = buildBondPrincipalAttorneySelectionHandler(
    updateData,
    data,
    selectionHandler
  );

  return (
    <>
      <BondGuardianAttorneySearchForPrincipal
        attorneySearch={attorneySearch}
        guardian={guardian}
        guardianIndex={guardianIndex}
        updateData={updateData}
        data={data}
        guardians={guardians}
        onSelect={onSelect}
        fieldError={fieldError}
        required={required}
      />
      {typeof children === "function" ? children(attorneys) : children}
    </>
  );
}

export default BondPrincipalAttorneySearchSection;
